import { TriangleAlert } from "lucide-react";

import style from "./MissingPcrsDetailsNotice.module.css";

// Blocking error notice: PCRS returned the patient-details but omitted one or
// more fields the CDM review decision depends on (e.g. the registration date
// that drives mid-month timing). Without them the review cannot be started or
// submitted, so we block review actions and list exactly what is missing.
export const MissingPcrsDetailsNotice = ({ missingFields = [] }) => {
  return (
    <div className={style.notice} role="alert">
      <TriangleAlert size={20} className={style.icon} />
      <div className={style.body}>
        <p className={style.text}>
          PCRS did not return all the patient details required for a CDM review,
          so reviews cannot be started or submitted for this patient. Please
          retry, or check the patient&apos;s PCRS record.
        </p>
        {missingFields.length > 0 && (
          <p className={style.text}>
            Missing: {missingFields.join(", ")}.
          </p>
        )}
      </div>
    </div>
  );
};
